/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";
import i18n from "../../../i18n";
import { PrivateRouterProps } from "../../../interface/route-interface";
import HeaderOptionsPopup from "../popup/header-options";
import { withOktaAuth } from "@okta/okta-react";
import { msalInstance } from "../../../core/authentication/entra/msal";
import { signOutAdmin } from "../../../utils/validateAdminSession";
import { Login } from "../../../core/authentication";
import {
  createSuggesticUser,
  setUserLanguage,
} from "../../../services/suggesticServices";
import {
  createAnonymousSession,
  fetchAccessToken,
  fetchIdTokenForLogInUser,
  removeHybrisSession,
  setAccessToken,
} from "../../../services/commerceServices/accessToken";
import {
  addCartEntries,
  getCartEntries,
  getOrCreateCart,
} from "../../../services/commerceServices/cartServices";

interface HeaderState {
  isLangPopupOpen: boolean;
  isUserPopupOpen: boolean;
  currentLanguage: string;
  sessionExpiryTime: any;
}

/**
 * Reusable React component - Header.
 *
 * @namespace Header
 */
class Header extends React.Component<any, PrivateRouterProps & HeaderState> {
  constructor(props: any & PrivateRouterProps) {
    super(props);
    this.state = {
      isLangPopupOpen: false,
      isUserPopupOpen: false,
      currentLanguage: "",
      sessionExpiryTime: "",
    };
  }

  componentDidMount = () => {

    /*This code is used to handle closing of pop-up on outside click */
    const concernedElement: Element | any =
      document.querySelector(".header-icons");
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        this.setState({
          isLangPopupOpen: false,
          isUserPopupOpen: false,
        });
      }
    });

    document.addEventListener("mousedown", (event) => {
      if (!concernedElement?.contains(event.target)) {
        this.setState({
          isLangPopupOpen: false,
          isUserPopupOpen: false,
        });
      }
    });
  };

  componentWillReceiveProps(props: any) {
    if (window.location.pathname === "/foundational") {
      let currentTime = Math.round(new Date().getTime() / 1000);
      let sessionExpiryTime = parseInt(
        localStorage.getItem("sessionExpiryTime") || ""
      );

      if (
        (props && props.i18n.language !== this.state.currentLanguage) ||
        (sessionExpiryTime && currentTime >= sessionExpiryTime)
      ) {
        this.setState(
          {
            currentLanguage:
              sessionStorage.getItem("languageTypeOfApp") || "en-us",
          },
          async () => {
            await createAnonymousSession().then(async (res: any) => {
              let value: any =
                currentTime +
                parseInt(
                  res && res.securityToken && res.securityToken.expiresIn
                );
              localStorage.setItem("sessionExpiryTime", value);

              if (res !== undefined && !localStorage.getItem("logout")) {

                if (
                  !localStorage.getItem("okta-token-storage") &&
                  res?.securityAccount?.userType !== "ANONYMOUS"
                ) {
                  localStorage.setItem(
                    "previousPath",
                    this.props.history?.location?.pathname
                  );
                  await Login(this.props.oktaAuth);
                }
              }

            });
          }
        );
      }
    }
  }

  /**
   * This method is used for handle language popup click
   *
   */
  handleLangPopup = () => {
    this.setState({
      isLangPopupOpen: !this.state.isLangPopupOpen,
      isUserPopupOpen: false,
    });
  };
  handleLangPopupKeyPress = () => {
    this.setState({
      isLangPopupOpen: !this.state.isLangPopupOpen,
      isUserPopupOpen: false,
    });
  };

  /**
   * This method is used for handle user popup click
   *
   */
  handleUserPopup = () => {
    this.setState({
      isUserPopupOpen: !this.state.isUserPopupOpen,
      isLangPopupOpen: false,
    });
  };
  handleUserPopupKeyPress = () => {
    this.setState({
      isUserPopupOpen: !this.state.isUserPopupOpen,
      isLangPopupOpen: false,
    });
  };

  /**
   * This method is used for handle user popup click
   *
   */
  handleUserAuthenticationOnKeyPress = async (
    event: any,
    isAuthenticated: boolean
  ) => {
    if (event.key === "Enter") {
      this.handleUserAuthentication(isAuthenticated);
    }
  };
  handleUserAuthentication = async (isAuthenticated: boolean) => {
    let oktaCred = this.props.location.pathname.includes("/admin") 
      ? sessionStorage.getItem("okta-token-storage") 
      : localStorage.getItem("okta-token-storage");

    localStorage.setItem(
      "previousPath",
      this.props.history?.location?.pathname
    );
    if (oktaCred) {
      await this.props.oktaAuth.signOut({}).then(() => {
        let currentLanguage = sessionStorage.getItem("languageTypeOfApp") || "en-us"
        localStorage.clear();
        sessionStorage.clear();
        sessionStorage.setItem("languageTypeOfApp", currentLanguage)
        localStorage.setItem("logout", "true");
      });
      this.setState({
        isUserPopupOpen: false,
        isLangPopupOpen: false,
      });
      //Clear Userinfo
      localStorage.removeItem("user-info");
    } else {
      this.setState({
        isUserPopupOpen: false,
        isLangPopupOpen: false,
      });
      await Login(this.props.oktaAuth).then(() => {
        // createSuggesticUser()
      });
    }
  };

  handleSignOut = () => {
    const isAdmin = this.props.location.pathname.includes("/admin");
    if (isAdmin) {
      signOutAdmin();
    } else {
      this.props.oktaAuth.signOut({
        postLogoutRedirectUri: `${window.location.origin}/`,
      })
    }
  };
  /**
   * This method is used for handle language popup
   *
   */
  updateContentLanguageOnClick = () => {
    //languageType is fetched from session storage here

    const language = sessionStorage.getItem("languageTypeOfApp") || "en-us";
    const languageType =
      language === null ? "es-us" : language === "en-us" ? "es-us" : "en-us";
    i18n.changeLanguage(languageType);
    //languageType is set on session storage here
    sessionStorage.setItem("languageTypeOfApp", languageType);
    this.setState({
      isLangPopupOpen: false,
    });

    //suggestic call for updating user language
    if (localStorage.getItem("uniqueId")) {
      setUserLanguage();
    }
  };
  updateContentLanguageOnKeyPress = (event: any) => {
    if (event.key === "Enter") {
      this.updateContentLanguageOnClick();
    }
  };

  redirectToHome = () => {
    this.props.history.push("/home");
  };

  render() {
    const { authState } = this.props;
    const languageType = sessionStorage.getItem("languageTypeOfApp") || "en-us";
    const isAdminRoute = this.props.location.pathname.includes("/admin")
    const adminSignedIn = !!msalInstance.getAllAccounts()?.length;
    const consumerSignedIn = !!localStorage.getItem("okta-token-storage");
    const userSignedIn = isAdminRoute ? adminSignedIn : consumerSignedIn;
    const checkPathName = isAdminRoute;

    return this.props.showHeader ? (
      <header className={checkPathName ? "header-container admin-header-container " : "header-container"}>
        <div className="inner-wrapper">
          <div className="header-title-wrapper">
            {/* <span className="icon leaves-icon"></span> */}
            <span
              className={`icon ${checkPathName ? 'wellness-admin-logo' : 'nutrilite-logo'}`}
              onClick={() => { !checkPathName && this.redirectToHome() }}
              aria-label={checkPathName ? "Wellness Admin Tool" : "Nutrilite"}
              title={checkPathName ? "Wellness Admin Tool" : "Nutrilite"}
            ></span>
          </div>

          {/* Header Icons wrapper Start */}
          <div className="header-icons">
            {!checkPathName &&
              <div className="icon-wrapper">
                <span
                  tabIndex={0}
                  role="button"
                  aria-expanded={this.state.isLangPopupOpen}
                  aria-label="Launguage translator"
                  className={
                    this.state.isLangPopupOpen
                      ? "icon lang-icon active"
                      : "icon lang-icon"
                  }
                  onClick={this.handleLangPopup}
                  onKeyPress={this.handleLangPopupKeyPress}
                ></span>
                <HeaderOptionsPopup
                  list={[
                    languageType === "en-us"
                      ? this.props.t("common.spanish_label")
                      : this.props.t("common.english_label"),
                  ]}
                  open={this.state.isLangPopupOpen}
                  handleOptionClick={this.updateContentLanguageOnClick}
                  handleOptionKeyPress={(e: any) =>
                    this.updateContentLanguageOnKeyPress(e)
                  }
                />
              </div>
            }

            <div className="icon-wrapper">
              {checkPathName ? (
                // Admin: inline SVG user button
                <button
                  type="button"
                  aria-label="Account"
                  aria-expanded={this.state.isUserPopupOpen}
                  onClick={this.handleUserPopup}
                  onKeyDown={this.handleUserPopupKeyPress}
                  className={this.state.isUserPopupOpen ? "user-btn active" : "user-btn"}
                  style={{
                    background: "none",
                    border: "none",
                    padding: 0,
                    cursor: "pointer",
                    display: "grid",
                    placeItems: "center",
                    width: 28,
                    height: 28,
                  }}
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="#111" aria-hidden="true">
                    <path d="M12 12c2.76 0 5-2.24 5-5S14.76 2 12 2 7 4.24 7 7s2.24 5 5 5zm0 2c-4.33 0-8 2.17-8 5v1h16v-1c0-2.83-3.67-5-8-5z" />
                  </svg>
                </button>
              ) : (
                // Consumer: sprite-based icon
                <span
                  tabIndex={0}
                  role="button"
                  aria-expanded={this.state.isUserPopupOpen}
                  aria-label="Login icon"
                  className={this.state.isUserPopupOpen ? "icon user-icon active" : "icon user-icon"}
                  onClick={this.handleUserPopup}
                  onKeyPress={this.handleUserPopupKeyPress}
                />
              )}

              <HeaderOptionsPopup
                list={
                  userSignedIn
                    ? [this.props.t("common.sign_out")]
                    : [this.props.t("common.sign_in")]
                }
                open={this.state.isUserPopupOpen}
                handleOptionClick={() => {
                  if (userSignedIn) {
                    this.handleSignOut();
                  } else {
                    if (isAdminRoute) {
                      // Admin: start MSAL login
                      msalInstance.loginRedirect();
                    } else {
                      // Consumer: use existing Okta-based login handler
                      this.handleUserAuthentication(
                        authState && authState.isAuthenticated
                      );
                    }
                  }
                }}
                handleOptionKeyPress={(e: any) =>
                  this.handleUserAuthenticationOnKeyPress(
                    e,
                    authState && authState.isAuthenticated
                  )
                }
              />
            </div>

            </div>{/* Header Icons wrapper Ends */}
          </div>
      </header>
    ) : null;
  }
}

export default withOktaAuth(Header);
